var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7713 12.438C10.7711 13.4382 9.4145 14.0001 7.99997 14.0001C6.58545 14.0001 5.22886 13.4382 4.22864 12.438C3.22842 11.4378 2.6665 10.0812 2.6665 8.66667C2.6665 7.25214 3.22842 5.89555 4.22864 4.89533C4.22864 4.89533 4.66664 6 5.99997 6.66667C5.99997 5.33333 6.33331 3.33333 7.99064 2C9.33331 3.33333 10.7266 3.85133 11.7706 4.89533C12.2667 5.39 12.6602 5.97783 12.9284 6.62504C13.1965 7.27226 13.3342 7.96609 13.3333 8.66667C13.3342 9.36719 13.1967 10.061 12.9287 10.7082C12.6606 11.3554 12.2673 11.9433 11.7713 12.438Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.586 10.7473C6.81826 10.9797 7.10417 11.1512 7.41846 11.2468C7.73276 11.3424 8.06576 11.3591 8.38803 11.2954C8.71031 11.2317 9.01194 11.0896 9.26628 10.8817C9.52061 10.6738 9.71981 10.4064 9.84627 10.1032C9.97273 9.80004 10.0226 9.47037 9.99136 9.14335C9.96016 8.81633 9.84888 8.50202 9.66737 8.22822C9.48585 7.95441 9.23969 7.72954 8.95062 7.57346C8.66156 7.41738 8.3385 7.33491 8.01 7.33334L7.33333 9.33334H6C6 9.84534 6.19533 10.3573 6.586 10.7473Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireOutline);
export default __webpack_public_path__ + "static/media/FireOutline.1b6126a2ab1fbc90eb8511e2e9b3a3ec.svg";
export { ForwardRef as ReactComponent };